import { EXTERNAL_LOGIN_PATH } from "../../../../../constants/env";

const CUSTOM_NEXT_URL_SCHEMES = ["bonusx-devx:", "bonusx-testx:", "bonusx-app:"];
const HTTPS_SCHEME = "https:";
const CONTROL_PARAMS = ["nextURL", "triggerRoute", "authenticationToken"];

function normalizeNextUrlScheme(rawNextUrl: string): string {
  const matchedScheme = CUSTOM_NEXT_URL_SCHEMES.find((scheme) => rawNextUrl.startsWith(scheme));
  if (!matchedScheme) {
    return rawNextUrl;
  }
  return `${HTTPS_SCHEME}${rawNextUrl.slice(matchedScheme.length)}`;
}

export function getSafeNextUrlPath(searchParams: URLSearchParams): string | null {
  const rawNextUrl = searchParams.get("nextURL");
  if (!rawNextUrl) {
    return null;
  }

  const normalizedNextUrl = normalizeNextUrlScheme(rawNextUrl);

  let parsed: URL;
  try {
    parsed = new URL(normalizedNextUrl, window.location.origin);
  } catch {
    return null;
  }

  const isSameOrigin = parsed.origin === window.location.origin;
  if (!isSameOrigin) {
    return null;
  }

  const isExternalLoginLoop = parsed.pathname.startsWith(EXTERNAL_LOGIN_PATH);
  if (isExternalLoginLoop) {
    return null;
  }

  const search = buildSearchWithSiblingParams(parsed.search, searchParams);

  return `${parsed.pathname}${search}${parsed.hash}`;
}

function buildSearchWithSiblingParams(existingSearch: string, searchParams: URLSearchParams): string {
  const siblingParams = new URLSearchParams();
  searchParams.forEach(function collectParam(value, key) {
    if (!CONTROL_PARAMS.includes(key)) {
      siblingParams.append(key, value);
    }
  });

  const siblingParamsString = siblingParams.toString();
  if (!siblingParamsString) {
    return existingSearch;
  }

  const separator = existingSearch ? "&" : "?";
  return `${existingSearch}${separator}${siblingParamsString}`;
}
